import React, { useState } from "react";
import NavLogo from "../assets/banner/nav-logo.webp";
import { Link } from "react-router-dom";

export default function NotFoundNavbar() {
  const [menuFixed, setMenuFixed] = useState(false);

  window.addEventListener("scroll", () => {
    if (window.scrollY > 200) {
      setMenuFixed(true);
    } else {
      setMenuFixed(false);
    }
  });

  return (
    <nav className={`header-nav d-flex align-items-center justify-content-between ${menuFixed ? "active" : ""}`}>
      <Link to="/" className="logo-brand">
        <img src={NavLogo} alt="Logo" className="img-fluid" width="120" height="30" />
      </Link>
    </nav>
  );
}
